import { useState } from 'react'
import { OptionTypeBase } from 'react-select'
import AsyncSelect from 'react-select/async'
import { filterStyles, CustomContainer, CustomOption } from './Filter'

// Assets
import styles from './AsyncFilter.module.scss'

// Constants
const DEFAULT_LOADING_MESSAGE = 'Loading items...'
const DEFAULT_PLACEHOLDER = 'Search by item name'

const getCustomComponentsAsObject = (list: CustomComponent[] | undefined) =>
  list?.reduce((acc: any, item: any) => {
    acc[item.originalName] = item.component
    return acc
  }, {})

type CustomComponent = {
  originalName: string
  component: React.ComponentType<any>
}

type AsyncFilterProps = {
  placeholder?: string
  loadingMessage?: string
  isDisabled?: boolean
  isOpen?: boolean
  customComponents?: CustomComponent[]
  noOptionsMessage?: () => string
  fetchItems: (inputValue: string, callback: (options: OptionTypeBase[]) => void) => void | Promise<any>
  onInputChange?: (newValue: string) => void
  onValueSelect?: (value: any) => void
}

const AsyncFilter: React.FC<AsyncFilterProps> = (props) => {
  // Props
  const {
    placeholder = DEFAULT_PLACEHOLDER,
    loadingMessage = DEFAULT_LOADING_MESSAGE,
    isDisabled = false,
    isOpen = false,
    customComponents,
    noOptionsMessage,
    fetchItems,
    onInputChange,
    onValueSelect,
  } = props

  // State
  const [selectedValue, setSelectedValue] = useState<OptionTypeBase | null>(null)
  const [menuIsOpen, setMenuIsOpen] = useState<boolean>(isOpen)

  // CustomStyles
  const customStyles = {
    ...filterStyles,
    indicatorsContainer: () => ({
      padding: 8 + 'px',
    }),
  }

  return (
    <div className={styles.container}>
      <AsyncSelect
        dataTestId={'async_filter'}
        menuIsOpen={menuIsOpen}
        noOptionsMessage={noOptionsMessage}
        placeholder={placeholder}
        value={selectedValue}
        styles={customStyles}
        components={{
          ...getCustomComponentsAsObject(customComponents),
          DropdownIndicator: () => null,
          Option: CustomOption,
          SelectContainer: CustomContainer,
        }}
        cacheOptions
        defaultOptions
        isClearable
        isDisabled={isDisabled}
        loadOptions={fetchItems}
        loadingMessage={() => loadingMessage}
        onInputChange={(value: string) => {
          setMenuIsOpen(!!value)
          onInputChange?.(value)
        }}
        onChange={(value: any) => {
          setSelectedValue(value)
          onValueSelect?.(value)
        }}
      />
    </div>
  )
}

export default AsyncFilter
